// must be < ES6 compliant (no import / export default)
module.exports = ['en', 'th']
